import { Component } from 'shimmer'

import { HDRCubeTextureLoader } from 'three/examples/jsm/loaders/HDRCubeTextureLoader'
import { HalfFloatType } from 'three'

export class EffectObject extends Component {
  constructor (scene, renderer) {
    super()

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.promises = []

    this.fullLoaded = this.fullLoaded.bind(this)
    this.treatObjects = this.treatObjects.bind(this)

    this.scene = scene
    this.renderer = renderer

    this.promisObjectLoaded = new Promise((resolve) => {
      this.resolveObject = resolve
    })

    const envMapPromise = this.loadEnvMap()

    this.promises.push(envMapPromise, this.promisObjectLoaded)

    Promise.all(this.promises).then(() => {
      this.resolve()
      this.treatObjects()
    })
  }

  fullLoaded () {
    this.resolveObject()
  }

  treatObjects () {
    this.scene.traverse( child => {

      this.neonObject(child)

      if (!child.isMesh) { return }

      if (child.material.envMap === null) {
        child.material.envMap = this.cubemap
        child.material.envMapIntensity = .004
        child.material.needsUpdate = true
      }
    })
  }

  neonObject (obj) {
    if (obj.name.startsWith('Neon_')) {
      obj.layers.enable(1)
      obj.traverse(child => child.layers.enable(1))
    }
  }

  loadEnvMap () {
    return new Promise( (resolve, reject) => {
      // const pmremGenerator = new PMREMGenerator( this.renderer );
      // pmremGenerator.compileCubemapShader()

      new HDRCubeTextureLoader().setDataType(HalfFloatType).setPath( '/images/textures/cubemap--01/' ).load([
        'px.hdr',
        'nx.hdr',
        'py.hdr',
        'ny.hdr',
        'pz.hdr',
        'nz.hdr'
      ], texture => {
        this.cubemap = texture

        // this.generatedCubeMap = pmremGenerator.fromCubemap( this.cubemap )

        // this.cubemap.minFilter = LinearFilter
        // this.cubemap.magFilter = LinearFilter
        // this.cubemap.needsUpdate = true

        // pmremGenerator.dispose()


        // this.pmremGenerator.dispose()
        // let nodeTexture = new TextureNode()
        // nodeTexture.value = this.hdrCubeRenderTarget.texture

        // this.texture = new TextureCubeNode( nodeTexture )

        // this.cubemap.magFilter = LinearFilter;
        // this.cubemap.needsUpdate = true

        // console.log('this.texture', nodeTexture)

        // console.log('this.hdrCubeRenderTarget', this.hdrCubeRenderTarget.texture)

        // hdrCubeMap.magFilter = LinearFilter
        // hdrCubeMap.needsUpdate = true

        // this.cubemap.generateMipmaps = false
        // this.cubemap.needsUpdate = true
        resolve()
      })
    })
  }
}